<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Channels
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Dashboard</li>
        <li class="active">Channels</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default">
            <div class="box-header with-border">
              <h3 class="box-title">Channel Summary</h3>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
                <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
              </div>
            </div>
            <!-- /.box-header -->
            <div class="loader" v-if="loading">
              <img src="/static/img/loader.gif" />
            </div>
            <div class="box-body" v-if="!loading">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="box-title">Users</h4>
                  <div class="chart-responsive">
                    <chartjs-bar :option="options" :height="200" :datalabel="label" :labels="channel_labels" :data="channel_accounts" :bind="true"
                                 :backgroundcolor="bgcolors"></chartjs-bar>
                  </div>
                  <!-- ./chart-responsive -->
                </div>
                <div class="col-md-6">
                  <h4 class="box-title">Referrals</h4>
                  <div class="chart-responsive" id="user-funnel">
                    <chartjs-bar :option="options" :height="200" :datalabel="label" :labels="channel_labels" :data="channel_referrals" :bind="true"
                                 :backgroundcolor="bgcolors"></chartjs-bar>
                  </div>
                  <!-- ./chart-responsive -->
                </div>
              </div>
              <!-- /.row -->
            </div>
          </div>
        </div>
      </div>


      <!--Channel Detail-->
      <div class="row">
        <div class="col-md-12">
          <div class="box box-solid">
            <div class="box-header with-border">
              <h3 class="box-title">Channel Details</h3>
            </div>
            <!-- /.box-header -->
            <div class="loader" v-if="loading">
              <img src="/static/img/loader.gif" />
            </div>
            <div v-if="!loading" class="box-body">
              <div class="box-group" id="accordion">
                <!-- we are adding the .panel class so bootstrap.js collapse plugin detects it -->
                <div v-for="channel in hasaccounts(channels)">
                  <div class="panel box box-primary">
                    <div class="box-header with-border">
                      <h4 class="box-title">
                        <a data-toggle="collapse" data-parent="#accordion" v-bind:href="'#'+channel.channel" aria-expanded="false" class="collapsed">
                          {{ channel.channel }}
                        </a>
                      </h4>
                      <span class="pull-right-container h4">
                        <small class="label pull-right bg-blue">{{ channel.referrals }}</small>
                        <small class="label pull-right bg-yellow">{{ channel.accounts }}</small>
                      </span>
                    </div>
                    <div v-bind:id="channel.channel" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                      <div class="box-body">
                        <div class="row">
                          <div class="col-md-8">
                            <div class="row">
                              <div class="col-md-12">
                                <h5 class="box-title">Users</h5>
                                <div class="chart-responsive">
                                  <chartjs-bar :option="options" :datalabel="channel.channel" :labels="channel.keywords.filter(keyword => keyword.accounts > 0).map(keyword => keyword.keyword)" :data="channel.keywords.filter(keyword => keyword.accounts > 0).map(keyword => keyword.accounts)" :bind="true"
                                               :backgroundcolor="bgcolors"></chartjs-bar>
                                </div>
                                <!-- ./chart-responsive -->
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <h5 class="box-title">Referrals</h5>
                                <div class="chart-responsive">
                                  <chartjs-bar :option="options" :datalabel="channel.channel" :labels="channel.keywords.filter(keyword => keyword.accounts > 0).map(keyword => keyword.keyword)" :data="channel.keywords.filter(keyword => keyword.accounts > 0).map(keyword => keyword.referrals)" :bind="true"
                                               :backgroundcolor="bgcolors"></chartjs-bar>
                                </div>
                                <!-- ./chart-responsive -->
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="row">
                              <div class="col-md-12">
                                <table class="table table-bordered table-striped">
                                  <thead>
                                  <tr>
                                    <th>Keyword</th>
                                    <th>Users</th>
                                    <th>Referrals</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="keyword in hasaccounts(channel.keywords)">
                                    <td>{{ keyword.keyword }}</td>
                                    <td>{{ keyword.accounts }}</td>
                                    <td>{{ keyword.referrals }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import { getGlobalKeywords }
    from '../../../utils/stats'

  export default {
    name: 'app-keywords-channel',
    data () {
      return {
        label: '#',
        labels: [],
        options: {
          legend: {
            display: false
          }
        },
        loading: true,
        channel_labels: [],
        channel_accounts: [],
        channel_referrals: [],
        channels: [],
        bgcolors: ['#0000FF', '#8A2BE2', '#A52A2A', '#DEB887', '#5F9EA0', '#7FFF00', '#D2691E', '#FF7F50', '#6495ED', '#FFF8DC', '#DC143C', '#00FFFF', '#00008B', '#008B8B', '#B8860B', '#A9A9A9', '#d4aaaa', '#006400', '#BDB76B', '#8B008B', '#556B2F', '#FF8C00', '#9932CC', '#8B0000', '#E9967A', '#8FBC8F', '#483D8B', '#2F4F4F', '#87bfbf', '#00CED1', '#9400D3', '#FF1493', '#00BFFF', '#696969', '#696969', '#1E90FF', '#B22222', '#FFFAF0', '#228B22', '#FF00FF', '#DCDCDC', '#F8F8FF', '#FFD700', '#DAA520', '#808080', '#d43939', '#7ca03c', '#ADFF2F', '#F0FFF0', '#FF69B4', '#CD5C5C', '#4B0082', '#FFFFF0', '#F0E68C', '#E6E6FA', '#FFF0F5', '#7CFC00', '#FFFACD', '#ADD8E6', '#F08080', '#E0FFFF', '#FAFAD2', '#D3D3D3', '#D3D3D3', '#90EE90', '#FFB6C1', '#FFA07A', '#20B2AA', '#87CEFA', '#778899', '#778899', '#B0C4DE', '#FFFFE0', '#00FF00', '#32CD32', '#FAF0E6', '#b4ce86']
      }
    },
    methods: {
      hasaccounts: (list) => {
        return list.filter((list) => list.accounts > 0)
      }
    },
    mounted () {
      // function for dynamic sorting
      function compareValues (key, order = 'asc') {
        return function (a, b) {
          if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0
          }
          const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key]
          const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key]
          let comparison = 0
          if (varA > varB) {
            comparison = 1
          } else if (varA < varB) {
            comparison = -1
          }
          return (
            (order === 'desc') ? (comparison * -1) : comparison
          )
        }
      }

      getGlobalKeywords().then((response) => {
        let data = response.data.payload
        this.channels = data.sort(compareValues('channel', 'asc'))
        for (let i = data.length - 1; i >= 0; i--) {
          if (data[i].accounts > 0) {
            this.channel_labels.push(data[i].channel)
            this.channel_accounts.push(data[i].accounts)
            this.channel_referrals.push(data[i].referrals)
          }
        }
        this.loading = false
      }).catch(function (error) {
        console.log(error)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// KeywordChannels.vue?1e5cb88d